'use strict';

export const ACTIVE_PLAN = 'ActivePlan';
export const ACTIVE_SUBSCRIPTION = 'ActiveSubscription';
export const NO_ACTIVE_PLAN = 'NoActivePlan';
export const PAST_DUE_SUBSCRIPTION = 'PastDueSubscription';
export const FAILED_SUBSCRIPTION = 'FailedSubscription';
export const CANCELLED_SUBSCRIPTION = 'CancelledSubscription';
